function getHoleScoreColor(scorecard, hole) {
    if (!scorecard) {
        return '';
    }

    const scorecardHoleResult = scorecard
        .attr('holeResults')
        .filter((el) => el.attr('hole.identifier') === hole)[0];
    if (
        !scorecardHoleResult ||
        scorecardHoleResult.attr('score.displayValue') === ''
    ) {
        return 'par';
    }

    const score = parseInt(scorecardHoleResult.attr('score.value')) || 0;
    const par = parseInt(scorecardHoleResult.attr('hole.par')) || 0;
    const diff = score - par;

    switch (true) {
        case diff <= -2:
            return 'eagle';
        case diff === -1:
            return 'birdie';
        case diff === 0:
            return 'par';
        case diff === 1:
            return 'bogey';
        case diff >= 2:
            return 'double-bogey';
    }
}

function getScoreName(scoreParam, parParam) {
    const score = parseInt(scoreParam) || 0;
    const par = parseInt(parParam) || 0;
    const diff = score - par;

    switch (diff) {
        case -2:
            return 'eagle';
        case -1:
            return 'birdie';
        case 0:
            return 'par';
        case 1:
            return 'bogey';
        case 2:
            return 'double-bogey';
    }
}

function getNextHole(roundsInfo, round) {
    if (!roundsInfo) {
        return 1;
    }
    const scorecard = roundsInfo.attr(`${round - 1}.scorecard`);
    const holeResults = (scorecard && scorecard.attr('holeResults')) || [];
    const startHole =
        roundsInfo.attr(`${round - 1}.startHole`) ||
        roundsInfo.attr(
            `${round - 1}.scorecard.holeResults.0.hole.identifier`,
        ) ||
        1;
    const startFrom10thHole = startHole === 10;

    let lastPlayedHole = null;
    holeResults.forEach((holeResult) => {
        if (holeResult.score.displayValue !== '') {
            lastPlayedHole = holeResult.hole.identifier;
        }
    });
    // round haven't started
    if (!scorecard || !holeResults.length || lastPlayedHole === null) {
        return startFrom10thHole ? 10 : 1;
    }
    // round finished
    if (scorecard.total.score.displayValue !== '') {
        return startFrom10thHole ? 9 : 18;
    }
    // round in progress
    if (startFrom10thHole) {
        if (lastPlayedHole < 9) {
            return lastPlayedHole + 1;
        }
        if (lastPlayedHole === 9) {
            return 9;
        }
        if (lastPlayedHole === 18) {
            return 1;
        }
        if (lastPlayedHole > 9) {
            return lastPlayedHole + 1;
        }
    } else {
        if (lastPlayedHole === 18) {
            return 18;
        }
        return lastPlayedHole + 1;
    }
    return 1;
}

export default {
    getHoleScoreColor,
    getNextHole,
    getScoreName,
};
